import React from 'react';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Typography, Divider } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BarChartIcon from '@mui/icons-material/BarChart';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

const MENU_ITEMS = [
  { id: 'proc-pagamento', label: 'Proc de pagamento', icon: <AssignmentIcon /> },
  { id: 'relatorio-mensal', label: 'Relatório mensal', icon: <AssessmentIcon /> },
  { id: 'dashboard', label: 'Dashboard', icon: <BarChartIcon /> },
  { id: 'atividades-notas-fiscais', label: 'Atividades de Notas Fiscais', icon: <AssignmentTurnedInIcon /> },
  { id: 'fluxo-notas-fiscais', label: 'Fluxo', icon: <AccountTreeIcon /> },
];

export default function NotasFiscaisLayout({ children, selectedMenu, onMenuChange }) {
  return (
    <Box sx={{ display: 'flex', minHeight: 'calc(100vh - 120px)' }}>
      {/* Menu lateral */}
      <Box
        sx={{
          width: 220,
          flexShrink: 0,
          borderRight: '1px solid #e0e0e0',
          bgcolor: '#fafafa',
          pt: 2,
          pb: 2
        }}
      >
        <Box sx={{ px: 2, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          <ReceiptIcon sx={{ color: '#1976d2', fontSize: 28 }} />
          <Typography variant="h6" fontWeight={600} color="primary">
            Notas Fiscais
          </Typography>
        </Box>
        <Divider sx={{ mb: 1 }} />
        <List dense>
          {MENU_ITEMS.map((item) => (
            <ListItemButton
              key={item.id}
              selected={selectedMenu === item.id}
              onClick={() => onMenuChange(item.id)}
              sx={{
                mx: 1,
                borderRadius: 1,
                mb: 0.5,
                pl: 2,
                '&.Mui-selected': {
                  bgcolor: 'rgba(25, 118, 210, 0.12)',
                  color: '#1976d2',
                  '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.18)' }
                }
              }}
            >
              <ListItemIcon sx={{ minWidth: 40, color: selectedMenu === item.id ? '#1976d2' : 'inherit' }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
            </ListItemButton>
          ))}
        </List>
      </Box>
      {/* Conteúdo */}
      <Box sx={{ flex: 1, overflow: 'auto', p: 3, bgcolor: '#fff' }}>
        {children}
      </Box>
    </Box>
  );
}
